import { Navigate, createFileRoute } from "@tanstack/react-router";
import { OnboardingOperation } from "../components/admin/onboarding-operation";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/onboarding/$operationId")({
  component: AdminOnboardingOperationPage,
});

function AdminOnboardingOperationPage() {
  const { operationId } = Route.useParams();
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return <OnboardingOperation operationId={operationId} />;
}
